import axios from "@/api/config_php";

export const getWalletRechargeRecord = param =>
  axios.get(`/amp/api/v1/rechargeRecords/lists`, { params: param });
// 钱包充值 汇率转换
export const usdToCNY = param =>
  axios.get(`/amp/api/v1/alicloudapi`, {
    params: param
  });

// 微信支付
export const wechatPay = param =>
  axios.post(`/amp/api/v1/payment/wechat`, param);

// 支付宝支付
export const aliPay = param => axios.post(`/amp/api/v1/payment/alipay`, param);
//支付宝获取充值状态
export const getAliPayResult = param =>
  axios.post(`/amp/api/v1/getRechargeInfo`, param);

// 美元支付
export const dollarPay = param =>
  axios.post(`/amp/api/v1/payment/offline`, param);

// 退款记录
export const getRefundList = param =>
  axios.get(`/amp/api/v1/clientRefund/lists`, { params: param });
// 获取常用账户
export const getRefundBanks = param =>
  axios.get(`/amp/api/v1/clientRefund/getRefundBank`, { params: param });
// 获取银行列表
export const getBanks = param =>
  axios.get(`/amp/api/v1/clientRefund/getBank`, { params: param });
// 申请退款
export const applyRefund = param =>
  axios.post(`/amp/api/v1/clientRefund/applyRefund`, param);
// 删除常用账号
export const delRefundBank = param =>
  axios.post(`/amp/api/v1/clientRefund/delRefundBank`, param);
// 撤回申请单
export const withdrawRefund = param =>
  axios.post(`/amp/api/v1/clientRefund/withdraw`, param);
// 退款详情
export const getClentRefund = param =>
  axios.get(`/amp/api/v1/clientRefund/getClentRefund`, { params: param });
// 广告账户导出
export const generateAccountMedia = param =>
  axios.post(`/amp/api/v1/taskcore/generateAccountMedia`, param);

// Facebook 封户账户列表导出
export const generateAccountClose = param =>
  axios.post(`/amp/api/v1/taskcore/generateAccountClose`, param);

// Facebook 封户账户列表导出
export const generateLarrReasion = param =>
  axios.post(`/amp/api/v1/taskcore/generateLarrReasion`, param);

//钱包余额变更记录列表 企业钱包
export const getBalanceRechargeRecord = param =>
  axios.get(`/amp/api/v1/changeRecord/lists`, { params: param });

// 钱包余额变更记录列表 导出
export const generateChangeRecord = param =>
  axios.post(`amp/api/v1/changeRecord/generateChangeRecord`, param);

// 客户组信息
export const getClientGrouplist = param =>
  axios.get(`/amp/api/v1/changeRecord/clientGrouplist`, { params: param });
